<template>
  <div class="editor-wrap">
    <editor
      ref="editor"
      v-model="innerValue"
      @input="handleInput"
      @init="editorInit"
      :theme="$vuetify.theme.dark ? 'dracula' : 'xcode'"
      :options="options"
      lang="python"
      height="calc(100vh - 50px)"
    />
    <div class="editor-wrap__footer">
      <v-divider />
      <div
        class="d-flex justify-end px-4"
        style="align-items: center; height: 100%;"
      >
        <v-btn text @click="$emit('close')">
          close
        </v-btn>
        <v-btn color="primary" text @click="$emit('save', innerValue)">
          save
        </v-btn>
      </div>
    </div>
  </div>
</template>

<script>
import {
  defineComponent,
  onMounted,
  reactive,
  ref,
  toRefs
} from '@vue/composition-api';

export default defineComponent({
  props: {
    code: {
      type: String,
      default: ''
    }
  },
  components: {
    editor: require('vue2-ace-editor')
  },
  name: 'CodeEditor',
  setup(props, { emit }) {
    const innerValue = ref(null);
    let editorInstance = null;

    const state = reactive({
      options: {}
    });

    const editorInit = editor => {
      editorInstance = editor;
      require('brace/mode/python');
      require('brace/theme/xcode');
      require('brace/theme/dracula');
      require('brace/ext/searchbox');
      require('brace/ext/modelist');
      require('brace/ext/beautify');
      require('brace/ext/error_marker');
      require('brace/ext/statusbar');
      require('brace/ext/themelist');
      require('brace/ext/whitespace');
      require('brace/ext/keybinding_menu');
      require('brace/ext/emmet');
      require('brace/ext/language_tools');
      require('brace/ext/static_highlight');
    };

    const handleInput = () => {
      let value = editorInstance.getValue().trim();
      emit('input', value || null);
    };

    onMounted(() => {
      if (props.code) {
        innerValue.value = props.code;
      }
    });

    return {
      ...toRefs(state),
      editorInit,
      innerValue,
      handleInput
    };
  }
});
</script>

<style lang="scss">
.editor-wrap {
  width: 100%;
  height: 100vh;
  position: relative;
  overflow: hidden;

  .ace_editor {
    font-size: 14px;
  }

  &__footer {
    background: #fff;
    z-index: 10;
    width: 100%;
    position: absolute;
    bottom: 0;
    right: 0;
    height: 50px;
  }
}

.theme--dark .editor-wrap__footer {
  background: #1e1e1e;
}
</style>
